import React from 'react'
import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import Page from '../../../components/page/page'
import PageHeader from '../../../components/page/pageHeader'
import { CustomIframe } from '../../../components/shared/customIframe/customIframe'
import { getActiveBalanceZone, getActiveCompany, getCustomerDomain } from '../../../redux'
import { useHistory } from 'react-router'
import { NonAuthRoutes } from '../../../model'
import { Button } from '@material-ui/core'
import { EnumClientTypes } from '../../../api/Argentia/enums/enumClientTypes'

export interface MarketerPageProps {}

export const MarketerPage: React.FC<MarketerPageProps> = props => {
  const apiSuffixUrl = 'https://' + getCustomerDomain()
  const [t] = useTranslation(['globalerisLibrary', 'translation', 'wholesaler', 'clientsMod'])
  const history = useHistory()

  // const apiSuffixUrl = 'https://localhost:44394';
  let activeCompany = getActiveCompany()
  let activeBalanceZone = getActiveBalanceZone()
  const [routeLocal, setRouteLocal] = useState(
    `${apiSuffixUrl}/clientes/productdata/comercializador`
  )

  useEffect(() => {
    call()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeCompany, activeBalanceZone])

  const call = async () => {
    setRouteLocal(
      `${apiSuffixUrl}/company/index/${activeCompany?.id}?idBalanceZone=${activeBalanceZone?.id}&company=${activeCompany?.description}&balanceZoneDescription=${activeBalanceZone?.description}`
    )

    setTimeout(() => {
      setRouteLocal(`${apiSuffixUrl}/clientes/productdata/comercializador`)
    }, 1000)
  }

  return (
    <Page>
      <PageHeader title={t('wholesaler:productsMay')}>
        <Button
          size="small"
          variant="text"
          color="primary"
          onClick={() => {
            history.push(NonAuthRoutes.Client)
          }}
        >
          {t('clientsMod:buttons.back')}
        </Button>
      </PageHeader>
      <CustomIframe
        route={decodeURI(routeLocal)}
        width="100%"
        height="1200"
        allowFullScreen={true}
      />
    </Page>
  )
}
